import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

const EMPTY = "__season_empty__";

// Native macOS option menus may ignore CSS font sizes; render the menu in-app.
export function SeasonSelect({ value, defaultValue, onChange, children, className, disabled, ...props }) {
  const options = React.Children.toArray(children).flatMap((child) => {
    if (!React.isValidElement(child)) return [];
    if (child.type === React.Fragment) return React.Children.toArray(child.props.children);
    return [child];
  });
  return <Select value={value == null ? undefined : String(value) || EMPTY}
    defaultValue={defaultValue == null ? undefined : String(defaultValue) || EMPTY}
    disabled={disabled} onValueChange={(next) => onChange?.({ target: { value: next === EMPTY ? "" : next } })}>
    <SelectTrigger {...props} data-season-selector="true" className={className}><SelectValue /></SelectTrigger>
    <SelectContent data-season-selector="true" className="max-h-80">
      {options.filter(React.isValidElement).map((option) => <SelectItem key={String(option.props.value)} value={String(option.props.value ?? "") || EMPTY} disabled={option.props.disabled} className="py-2.5">{option.props.children}</SelectItem>)}
    </SelectContent>
  </Select>;
}
